export default __webpack_public_path__ + "content/media/5.36ee750c.jpg";